<script setup lang="ts">
import type { SaleItemEntity } from '~/types/sale.type';
import { isAuction } from '~/types/sale.type';

// PROPS
interface Props {
    sale: SaleItemEntity;
}
const props = defineProps<Props>();

// COMPOSABLES
const { tt } = useTypedI18n();

// COMPUTED
const showBidsCount = computed((): boolean => isAuction(props.sale) && props.sale.numberOfBids > 0);

const showVisitorsCount = computed((): boolean => !!props.sale.visitorsCount && props.sale.visitorsCount > 0);

const isVisible = computed((): boolean => showBidsCount.value || showVisitorsCount.value);
</script>

<template>
    <div v-if="isVisible" class="bg-primary-50 space-y-1 rounded-xl px-6 py-2">
        <p v-if="showBidsCount && isAuction(sale)">
            {{ tt('sdp.numberOfBids', { count: sale.numberOfBids }) }}
        </p>
        <p v-if="showVisitorsCount">
            {{ tt('sdp.visitorsCount', { count: sale.visitorsCount }) }}
        </p>
    </div>
</template>
